﻿$.fn.dxCtrlSondageQuestionChk = function custom_dxCtrlSondageQuestionChk(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestionchk dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionChk(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionChk = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        if (typeof option.dataQuestion.nb_min == 'undefined') option.dataQuestion.nb_min = 0
        if (typeof option.dataQuestion.nb_max == 'undefined') option.dataQuestion.nb_max = 0
        if (typeof option.dataQuestion.order_reponse == 'undefined') option.dataQuestion.order_reponse = false

        //minRep/maxRep/ordered/

        //$("<div style='font-size:140%;'/>").appendTo(container).html("Liste de proposition à choix multiple")

        var $Table = $("<table style='width:100%;margin-top:20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $("<div>Nombre de réponse minimum obligatoire:</div>").appendTo($Td)
        $("<div style='font-style:italic;font-size:80%;'>0 = pas de minimum</div>").appendTo($Td)
        var $Td = $("<td style='width:120px;'/>").appendTo($Tr)
        $("<div style='margin:5px 0;display:inline-block;'/>").appendTo($Td).dxCtrlNumberBox({
            width: 150,
            labelMode: "floating",
            label: "Minimum",
            value: option.dataQuestion.nb_min,
            isFloat: false,
            default: 0,
            min: 0,
            max: 100,
            buttonLeftRight: true,
            showSpinButtons: false,
            onValueChanged: function (e) {
                option.dataQuestion.nb_min = e.value
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlNumberBox("instance")

        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $("<div>Nombre de réponse maximum:</div>").appendTo($Td)
        $("<div style='font-style:italic;font-size:80%;'>0 = pas de maximum</div>").appendTo($Td)
        var $Td = $("<td style='width:120px;'/>").appendTo($Tr)
        $("<div style='margin:5px 0;display:inline-block;'/>").appendTo($Td).dxCtrlNumberBox({
            width: 150,
            labelMode: "floating",
            label: "Maximum",
            value: option.dataQuestion.nb_max,
            isFloat: false,
            default: 0,
            min: 0,
            max: 100,
            buttonLeftRight: true,
            showSpinButtons: false,
            onValueChanged: function (e) {
                option.dataQuestion.nb_max = e.value
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlNumberBox("instance")

        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $("<div>Ordonner les réponses:</div>").appendTo($Td)
        $("<div style='font-style:italic;font-size:80%;'>L'ordre dans lequel les choix sont fait est enregistré et numéroté.<br/>La première réponse compte plus que la seconde qui compte plus que la troisème et ainsi de suite. EX: Si 3 choix sélectionné, 1er choix=3 point, 2ème choix=2 point, 3ème choix=1 point.</div>").appendTo($Td)
        var $Td = $("<td style='width:120px;text-align:center;'/>").appendTo($Tr)
        $("<div style='margin:5px 0;display:inline-block;'/>").appendTo($Td).dxCheckBox({
            value: option.dataQuestion.order_reponse,
            onValueChanged: function (e) {
                option.dataQuestion.order_reponse = e.value
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlNumberBox("instance")


        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $("<div>Présentation des choix:</div>").appendTo($Td)
        var $Td = $("<td style='min-width:160px;text-align:center;'/>").appendTo($Tr)
        $("<div style='margin:5px 0;display:inline-block;'/>").appendTo($Td).dxSelectBox({
            labelMode: "floating",
            label: "Orientation",
            placeholder: "",
            dataSource: ["horizontale", "verticale"],
            value: option.dataQuestion.presentation,
            onValueChanged: function (e) {
                option.dataQuestion.presentation = e.value
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlNumberBox("instance")

        $("<div style='margin-top:20px;'/>").appendTo(container).dxCtrlHtmlEditorSimple({
            labelMode: "floating",
            label: "Texte d'introduction à la question",
            value: option.dataQuestion.text_intro,
            onValueChanged: function (e) {
                option.dataQuestion.text_intro = (e.value == null ? "" : e.value)
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        })
        //$("<div style='margin-top:20px;'/>").appendTo(container).dxTextArea({
        //    labelMode: "floating",
        //    label: "Texte d'introduction à la question",
        //    value: option.dataQuestion.text_intro,
        //    onValueChanged: function (e) {
        //        option.dataQuestion.text_intro = (e.value == null ? "" : e.value)
        //        option.sondage.mSave()
        //        if (option.onValueChanged) option.onValueChanged()
        //    }
        //})

        var $Table = $("<table style='width:100%;margin-top:20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var dxPhrasePlus = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Texte pour une proposition",
            value: ""
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-plus",
            onClick: function (e) {
                if (dxPhrasePlus.option("value") == null || dxPhrasePlus.option("value").length == 0) {
                    mNotify("Veuillez saisir une valeur à rajouter", "warning", 6000)
                    dxPhrasePlus.focus()
                    return
                }
                option.dataQuestion.last_id_phrase += 1
                option.dataQuestion.lst_phrase.push({
                    id_phrase: option.dataQuestion.last_id_phrase,
                    txt: dxPhrasePlus.option("value")
                })
                dxLst.reload()
                dxPhrasePlus.option("value", "")
                if (option.onValueChanged) option.onValueChanged()
            }
        })

        var dxLst = $("<div style='width:80%;margin:0 10%'/>").appendTo(container).dxList({
            scrollingEnabled: false,
            dataSource: option.dataQuestion.lst_phrase,
            repaintChangesOnly: true,
            allowItemDeleting: true,
            itemDeleteMode: 'toggle',
            onItemDeleted: function () {
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            },
            itemDragging: {
                allowReordering: true,
                data: option.dataQuestion.lst_phrase,
                group: 'phrases',
                onDragStart(e) {
                    e.itemData = e.fromData[e.fromIndex];
                },
                //onAdd(e) {
                //    e.toData.splice(e.toIndex, 0, e.itemData);
                //    e.component.reload();
                //},
                //onRemove(e) {
                //    e.fromData.splice(e.fromIndex, 1);
                //    e.component.reload();
                //},
                onReorder({
                    fromIndex, toIndex, fromData, component,
                }) {
                    const item = fromData.splice(fromIndex, 1)[0];
                    option.dataQuestion.lst_phrase.splice(toIndex, 0, item);
                    option.sondage.mSave()
                    component.reload();
                    if (option.onValueChanged) option.onValueChanged()
                },
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding", "5px")
                var $Div = $("<div style='padding:5px;border:" + theme.border + ";box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);'/>").appendTo(itemElement)
                var $Table = $("<table style='width:100%;table-layout:fixed'/>").appendTo($Div)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Tr)
                $Td.text(itemData.txt)
                itemElement.attr("title", itemData.txt)
                //var $Td = $("<td style='width:36px;vertical-align:top;'/>").appendTo($Tr)
                //$("<div/>").appendTo($Td).dxCtrlButton({
                //    icon: "fas fa-xmark",
                //    hint: "Supprimer définitivement",
                //    onClick: function (e) {
                //        option.dataQuestion.lst_phrase.splice(option.dataQuestion.lst_phrase.indexOf(itemData), 1);
                //        option.sondage.mSave()
                //        dxLst.reload();
                //        if (option.onValueChanged) option.onValueChanged()
                //    }
                //})
            },
            onItemClick: function (e) {
                var itemData = e.itemData
                if (!itemData) itemData = option.dataQuestion.lst_phrase[e.itemIndex]
                var dxTxtOption = null
                mConfirmPopup(function (contentElement) {
                    dxTxtOption = $("<div/>").appendTo(contentElement).dxTextBox({
                        labelMode: "floating",
                        label: "Option",
                        value: itemData.txt,
                        maxLength: 500,
                        onContentReady: function (e) {
                            window.setTimeout(function () { dxTxtOption.focus() }, 500)
                        }
                    }).dxTextBox("instance")
                },
                    function (pop) {
                        if (dxTxtOption.option("value") == null || dxTxtOption.option("value").length == 0) {
                            mNotify("Veuillez saisir une valeur pour l'option", "warning", 6000)
                            return;
                        }
                        itemData.txt = dxTxtOption.option("value")
                        option.sondage.mSave()
                        dxLst.reload();
                        if (option.onValueChanged) option.onValueChanged()
                        pop.hide()
                    }, "Valider",
                    function () {
                    }, "Annuler", null, true, "Modifier l'option")
            }
        }).dxList("instance")
    }

    this.element = function () { return container }

    mConstruit();
}